import { Outlet, Route, Routes } from "react-router-dom";

import { Nav } from "../../components/nav";
import { useLocale } from "../../stores/locale";
import { Apartment } from "./apartment";
import { ApartmentCreate } from "./apartment-create";
import { ApartmentDelete } from "./apartment-delete";
import { ApartmentEdit } from "./apartment-edit";
import { Apartments } from "./apartments";
import { HoldingCreate } from "./holding-create";
import { HoldingDelete } from "./holding-delete";
import { HoldingEdit } from "./holding-edit";
import { Holdings } from "./holdings";
import { LeaseCreate } from "./lease-create";
import { LeaseDelete } from "./lease-delete";
import { LeaseEdit } from "./lease-edit";
import { Leases } from "./leases";
import { OrganizationCreate } from "./organization-create";
import { OrganizationDelete } from "./organization-delete";
import { OrganizationEdit } from "./organization-edit";
import { Organizations } from "./organizations";
import { Overview } from "./overview";
import { PersonCreate } from "./person-create";
import { PersonDelete } from "./person-delete";
import { PersonEdit } from "./person-edit";
import { Persons } from "./persons";
import { SubletCreate } from "./sublet-create";
import { SubletDelete } from "./sublet-delete";
import { SubletEdit } from "./sublet-edit";
import { Sublets } from "./sublets";

export function Registers() {
  const t = useLocale((state) => state.locale);

  return (
    <>
      <Nav
        className="mb-4"
        items={[
          { title: t.overview.overview, slug: "/admin/register/overview" },
          { title: t.apartment.apartments, slug: "/admin/register/apartment" },
          { title: t.holding.holdings, slug: "/admin/register/holding" },
          { title: t.lease.leases, slug: "/admin/register/lease" },
          { title: t.sublet.sublets, slug: "/admin/register/sublet" },
          { title: t.person.persons, slug: "/admin/register/person" },
          {
            title: t.organization.organizations,
            slug: "/admin/register/organization",
          },
        ]}
      />
      <Routes>
        <Route element={<Overview />} path="/overview" />
        <Route element={<Apartments />} path="/apartment">
          <Route element={<Apartment />} path=":id" />
          <Route element={<ApartmentCreate />} path="create" />
          <Route element={<ApartmentEdit />} path=":id/edit" />
          <Route element={<ApartmentDelete />} path=":id/delete" />
        </Route>
        <Route element={<Holdings />} path="/holding">
          <Route element={<HoldingCreate />} path="create" />
          <Route element={<HoldingEdit />} path=":id/edit" />
          <Route element={<HoldingDelete />} path=":id/delete" />
        </Route>
        <Route element={<Leases />} path="/lease">
          <Route element={<LeaseCreate />} path="create" />
          <Route element={<LeaseEdit />} path=":id/edit" />
          <Route element={<LeaseDelete />} path=":id/delete" />
        </Route>
        <Route element={<Sublets />} path="/sublet">
          <Route element={<SubletCreate />} path="create" />
          <Route element={<SubletEdit />} path=":id/edit" />
          <Route element={<SubletDelete />} path=":id/delete" />
        </Route>
        <Route element={<Persons />} path="/person">
          <Route element={<PersonCreate />} path="create" />
          <Route element={<PersonEdit />} path=":id/edit" />
          <Route element={<PersonDelete />} path=":id/delete" />
        </Route>
        <Route element={<Organizations />} path="/organization">
          <Route element={<OrganizationCreate />} path="create" />
          <Route element={<OrganizationEdit />} path=":id/edit" />
          <Route element={<OrganizationDelete />} path=":id/delete" />
        </Route>
      </Routes>
      <Outlet />
    </>
  );
}
